export default __webpack_public_path__ + "static/media/smartplan_navicon-light.e48ade92.svg";